<template>
    <a @click="handleClick($event)" v-bind="$props" :class="classObject" v-if="!!href">
        <slot></slot>
    </a>
    <button v-bind="$props" @click="handleClick($event)" :class="classObject" v-else>
        <slot></slot>
    </button>
</template>

<script>
  export default {
    name: 'u-button',
    props: {
      type: {
        type: String,
        default: 'button'
      },
      disabled: Boolean,
      href: String,
      toggleClass: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        isActive: false
      }
    },
    methods: {
      handleClick (e) {
        this.$emit('click', e)
        if (this.toggleClass !== null) {
          this.handleToggle()
        }
      },
      handleToggle () {
        this.isActive = !this.isActive
        this.$nextTick(() => {
          if (this.isActive) {
            this.$el.className += ' ' + this.toggleClass
          } else {
            this.$el.className = this.$el.className.replace(this.toggleClass, '')
          }
        })
      }
    },
    computed: {
      classObject: function () {
        return {
          active: this.isActive
        }
      }
    }
  }
</script>

<!--<style lang="stylus"></style>-->



// WEBPACK FOOTER //
// UButton.vue?027e1224